export interface ProfileNameSources {
  google?: { given_name?: string | null; family_name?: string | null } | null;
  telegram?: { nickname?: string | null; username?: string | null } | null;
  stored?: string | null;
}

// `tg_<digits>` is the handle written for a Telegram user with no real one.
const PLACEHOLDER_HANDLE = /^tg_\d+$/i;
// Older sign-ins stored the concatenation of two missing names as the nickname.
const STRINGIFIED_NOTHING = /^(undefined|null)( (undefined|null))?$/;

const usable = (name?: string | null): string => {
  const trimmed = (name ?? "").trim();
  return PLACEHOLDER_HANDLE.test(trimmed) || STRINGIFIED_NOTHING.test(trimmed) ? "" : trimmed;
};

/** The profile's Name field: the first real name, or "" when there is none. */
export const profileDisplayName = ({ google, telegram, stored }: ProfileNameSources): string => {
  const googleName = [usable(google?.given_name), usable(google?.family_name)]
    .filter(Boolean)
    .join(" ");
  return googleName || usable(telegram?.nickname) || usable(telegram?.username) || usable(stored);
};
